export function printCalendar() {
    const button = document.querySelector('.__print_calendar__button');
    if(!button) return;
    button.addEventListener('click',()=>{
        window.print();
    });
}